import axios from 'axios';
import queryString from 'query-string';
import { API_URL } from '../config';

export const fetchClaim = async (payload) => {
  const URL = `${API_URL}/claim`;
  return axios.get(URL, {
    params: payload,
  }).then((resp) => resp.data);
};

export const submitClaimForm = async (type, data) => {
  const URL = `${API_URL}/claim-application/${type}`;
  return axios.post(URL, data).then((response) => response.data);
};

export const fetchManufacturers = async () => {
  const URL = `${API_URL}/transport-manufacturer`;
  return axios.get(URL).then((response) => response.data);
};

export const fetchManufacturerModels = async (mId) => {
  const URL = `${API_URL}/transport-manufacturer/${mId}/transport-model`;
  return axios.get(URL).then((response) => response.data);
};

export const searchForMedicalApplicant = async (data) => {
  const params = queryString.stringify(data);
  const URL = `${API_URL}/claim-application/medical-applicant?${params}`;
  return axios.get(URL).then((response) => response.data);
};

export const searchForCascoApplicant = async (data) => {
  const params = queryString.stringify(data);
  const URL = `${API_URL}/claim-application/casco-applicant?${params}`;
  return axios.get(URL).then((response) => response.data);
};

export const searchForPropertyApplicant = async (data) => {
  const params = queryString.stringify(data);
  const URL = `${API_URL}/claim-application/applicant/property?${params}`;
  return axios.get(URL).then((response) => response.data);
};
